<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REPORTE PERSONAS ATENDIDOS</h5>

        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label>Fecha Inicio:</label>
              <input
                type="date"
                v-model="fechaInicio"
                class="form form-control"
              />
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label>Fecha Fin:</label>
              <input type="date" v-model="fechaFin" class="form form-control" />
            </div>
          </div>
          <div class="col-lg-2">
            <label style="color:#FFFFFF">...</label><br />
            <a
              @click="BuscarPorDia(fechaInicio, fechaFin)"
              class="btn btn-primary"
              ><i class="fa fa-search"> Buscar</i></a
            >
          </div>
        </div>
        <div class="text-center" v-if="cargando">
          <i class="fa fa-spinner fa-pulse fa-5x"></i>
          <h4 class="mt-2">Cargando Datos...</h4>
        </div>

        <div class="card-body">
          <div class="row">
            <!--Isquierda-->
            <div class="col-12 col-md-6">
              <h6>Reporte por Vuelo</h6>
              <div class="col-md-6">
                <a
                  @click="exportarPorVuelosXls()"
                  class="btn btn-success"
                  ><i class="fa fa-download"><small> DESCARGAR</small></i></a
                >
              </div>
              <br />
              <div
                class="table-responsive"
                style="overflow-y:scroll; height:360px;"
              >
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th><small class="font-weight-bold">NRO</small></th>
                      <th><small class="font-weight-bold">EMPRESA</small></th>
                      <th><small class="font-weight-bold">ORIGEN DESTINO</small></th>
                      <th><small class="font-weight-bold">TOTAL</small></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in resultadosPorVuelo" :key="index">
                      <td class="text-center">
                        <small>{{ index + 1 }}</small>
                      </td>
                      <td>
                        <small>{{ item.nombre_empresa }}</small
                        ><br />
                        <small class="font-size-10"
                          >NUMERO DE VUELO: {{ item.nro_vuelo }}</small
                        >
                      </td>
                      <td>
                        <small>{{ item.ruta_itinerario }}</small>
                      </td>
                      <td class="text-center">
                      <small>{{ item.count }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!--Derecha-->
            <div class="col-12 col-md-6">
              <h6>Reporte por Día</h6>
              <div class="col-md-6">
                <a
                  @click="exportarPorDiaXls(fechaInicio, fechaFin)"
                  class="btn btn-success"
                  ><i class="fa fa-download"><small> DESCARGAR</small></i></a
                >
              </div>
              <br />
              <div
                class="table-responsive"
                style="overflow-y:scroll; height:360px;"
              >
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th><small class="font-weight-bold">NRO</small></th>
                      <th>
                        <small class="font-weight-bold">FECHA VUELO</small>
                      </th>
                      <th><small class="font-weight-bold">ORIGEN DESTINO</small></th>
                      <th><small class="font-weight-bold">TOTAL</small></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in registros" :key="index">
                      <td class="text-center">
                        <small>{{ index + 1 }}</small>
                      </td>
                      <td>
                        <small>{{ formatFecha(getDate(item.fecha_reg)) }}</small
                        ><br />
                        <small class="font-size-10"
                          >EMPRESA: {{ item.nombre_empresa }}</small
                        >
                      </td>
                      <td>
                        <small>{{ item.ruta_itinerario }}</small>
                      </td>
                      <td class="text-center">
                       <small>{{ item.count }}</small
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import { required, minLength} from "vuelidate/lib/validators";
import moment from "moment";

//const letras = helpers.regex("alpha", /^[a-zA-Z ]*$/);
//const numero = helpers.regex("alpha", /^[-1234567890]*$/);

export default {
  components: {
    Loading,
  },
  data() {
    return {
      registros: [],
      resultados: [],
      resultadosPorVuelo: [],
      fechaInicio: new moment().format("YYYY-MM-DD"),
      fechaFin: new moment().format("YYYY-MM-DD"),
      options: [],
  
      buscar: "",
  
      cargando: false,
      fechaMin: new moment().format("YYYY-MM-DD"),
    };
  },
  methods: {

  
    async listarDatosPorVuelo() {
      try {
        this.cargando = true;
        let resultados = await this.axios.get(`/getListaPorVuelos`);
        if (resultados.status == 200) {
          this.cargando = false;
          this.resultadosPorVuelo = resultados.data.contenido;
        }
      } catch (error) {
        this.cargando = false;
        console.log(error);
      }
    },
   
 
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      if (str != "" && str != null) {
        let arrayFecha = str.split("-");
        return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      } else {
        return "";
      }
    },
    ofusca: function(cadena) {
      return window.btoa(cadena);
    },

    async BuscarPorDia(fechaInicio, fechaFin) {
     
      try {
        this.resultados = await this.axios.get(
          `/busquedaVuelosDias/'${fechaInicio}'/${fechaFin}`
        );
        this.registros = this.resultados.data.contenido;
      } catch (error) {
        console.log(error);
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },

    async exportarPorVuelosXls() {
      let config = { headers: { token: this.token }, responseType: "blob" };
      this.cargando = true;
      try {
        let resultados = await this.axios.get(
          `/reporteVuelos_xls`,
          config
        );
        
        await this.crearDescarga(resultados, "reporte.xlsx");

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },

      async exportarPorDiaXls(fechaInicio, fechaFin){
     
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/reportePorVuelosDias/${fechaInicio}/${fechaFin}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    }


  },
  validations: {
    usuario: {
      direccion: { required, minLength: minLength(6) },
    },
  },
  created() {
    this.listarDatosPorVuelo();

  },
};
</script>
